import {AbstractTabs} from "./abstractTabs"
import {direction, wordings, EDITOR_TYPES, Selector} from "../mixins/dictionaries"
import {rangeOverlapStart, customizeDictionaryString, html, loadModal, fixOffsetScrollPosition} from "./utils";

export default class Tabs extends AbstractTabs {
    constructor(initSettings, mediator) {
        const tabSettings = {
            ...initSettings,
            "id": "tabs"
        };
        super(tabSettings);

        this.mediator = mediator;

        super.addEventsTabs();
        this.EventsOn()
    }

    loadSequence(data) {
        this.srcData = {
            name: data.name ?? "",
            slots: data.slots ?? []
        }
        this.sequenceLength = parseInt(data.sequence.length);
    }

    setAnnotations(data) {
        super.setAnnotations(data);

        this.addAnnotationItems(this.annotations);
        this.addEventItems();
    }

    setData(data) {
        if (data.sequence) {
            this.loadSequence(data);
        }
        this.render(data);
    }

    setAreaView(data) {
        this.areaViewSize = data.width;
    }

    render(data) {
        this.setAnnotations(data);
    }

    loadRestrictionEnzymes(data) {
        this.drawRestrictionEnzymes(data)
        this.bindEventsRE()
        if (this.filtersOn["enzymes-list"]) {
            this.filterRowsTabs("enzymes-list", this.filtersOn["enzymes-list"])
        }
    }

    addAnnotationItems(annotations) {
        this.addCodingSequencesItems(annotations.filter(a => a.tab === "cds"));
        this.addOthersItems(annotations.filter(a => a.tab === "annotations"));
    }

    addCodingSequencesItems(rows) {
        super.resetTabs(Selector.CODING_SEQUENCES_TAB, 'aminos-list');

        if (!rows.length) {
            super.noRows(Selector.CODING_SEQUENCES_TAB, customizeDictionaryString(wordings["no_items"], "coding sequences"));
        } else {
            super.addTableItems(rows, Selector.CODING_SEQUENCES_TAB, 'aminos-list', this.srcData.hasOwnProperty('slots') && this.srcData.slots.length)
            if (this.filtersOn["aminos-list"]) {
                this.filterRowsTabs("aminos-list", this.filtersOn["aminos-list"])
            }
        }
    }

    addOthersItems(rows) {
        super.resetTabs(Selector.OTHER_ANNOTATIONS_TAB, 'others-list');

        if (!rows.length) {
            super.noRows(Selector.OTHER_ANNOTATIONS_TAB, customizeDictionaryString(wordings["no_items"], "annotations"));
        } else {
            super.addTableItems(rows, Selector.OTHER_ANNOTATIONS_TAB, 'others-list', this.srcData.hasOwnProperty('slots') && this.srcData.slots.length)
            if (this.filtersOn["others-list"]) {
                this.filterRowsTabs("others-list", this.filtersOn["others-list"])
            }
        }
    }

    addEventItems() {
        this.bindEventsAnnotations('aminos-list', "coding_sequences");
        this.bindEventsAnnotations('others-list', "others");
    }

    bindEventsAnnotations(tabListClassName, category) {
        const selectRangeContainers = document.querySelectorAll(`ul.${tabListClassName} li.list-group-item a:not([data-variant-card]), ul.${tabListClassName} li.list-group-item button:nth-of-type(1)`);
        const detailVariantButtons = document.querySelectorAll(`ul.${tabListClassName} li.list-group-item button:nth-of-type(2)`)
        const checkButtons = document.querySelectorAll(`.${tabListClassName} .item input`);

        if (checkButtons.length) {
            this.toggleAllCheckboxes(tabListClassName, category);
            this.toggleItemCheckboxes(tabListClassName, category);
            this.selectRangeItem(selectRangeContainers);
            this.openVariantDetail(detailVariantButtons)
        }
    }

    bindEventsRE() {
        const containers = document.querySelectorAll('ul.enzymes-list i')
        const checkButtons = document.querySelectorAll(`ul.enzymes-list .list-group-item-secondary input[type='checkbox']`);
        if (checkButtons.length) {
            this.toggleAllCheckboxes('enzymes-list', 'restEnzymes');

            this.selectRangeItem(containers);
            this.toggleItemCheckboxes('enzymes-list', 'restEnzymes');
        }
    }

    toggleAllCheckboxes(content, selector) {
        const allCheckboxes = document.querySelector('.switchAll-' + content);
        if (allCheckboxes) {
            allCheckboxes.addEventListener('click', () => {
                const checkBoxItems = document.querySelectorAll(`.${content} li.list-group-item:not(.d-none) input.form-check-input`);
                const items = super.toggleItems(checkBoxItems, content, allCheckboxes.checked);

                this.EventsTrigger("toggleObjects", {
                    "selector": selector === "restEnzymes" ? "restrictionEnzymes" : "annotations",
                    "objects": items,
                    "visible": allCheckboxes.checked
                });
            })
        }
    }

    toggleItemCheckboxes(content, selector) {
        const checkBoxItems = document.querySelectorAll(`.${content} li.list-group-item:not(.d-none) input.form-check-input`);

        checkBoxItems.forEach(checkbox => {
            checkbox.addEventListener('click', () => {
                let items = [];

                if (!checkbox.dataset.pk) {
                    /**
                     * sub restriction Enzyme items
                     * */
                    const collapseGroup = document.querySelector(`#${checkbox.dataset.group}`)
                    const subCheckBoxes = collapseGroup.querySelectorAll("input[type='checkbox']");
                    subCheckBoxes.forEach(el => {
                        el.checked = checkbox.checked;

                        items.push(parseInt(el.dataset.pk));
                    })
                } else {
                    /**
                     * annotation items
                     * */
                    items.push(parseInt(checkbox.dataset.pk));

                    if (!checkbox.checked) {
                        this.hiddenAnnotations.push(parseInt(checkbox.dataset.pk))
                    } else {
                        this.hiddenAnnotations = this.hiddenAnnotations.filter(item => item !== parseInt(checkbox.dataset.pk))
                    }
                }

                this.EventsTrigger("toggleObjects", {
                    "selector": selector === "restEnzymes" ? "restrictionEnzymes" : "annotations",
                    "objects": items,
                    "visible": checkbox.checked
                })

                if (this.settings.editorType === EDITOR_TYPES.cloningrequest) {
                    this.addToQuote()
                }
            })
        })
    }

    selectRangeItem(containers) {
        containers.forEach((el) => {
            el.addEventListener('click', () => {
                const start = parseInt(el.dataset.start);
                let end = parseInt(el.dataset.end);

                this.EventsTrigger("selectRange", {
                    "start": start,
                    "end": rangeOverlapStart(start, end, this.sequenceLength)
                })

                let offsetScroll = start;

                if (!this.settings.circular) {
                    const maxEdgeOffsetScroll = this.sequenceLength - this.areaViewSize;
                    offsetScroll -= Math.round(this.areaViewSize / 2);
                    offsetScroll = fixOffsetScrollPosition(offsetScroll, maxEdgeOffsetScroll)
                }

                this.EventsTrigger("setOffsetScroll", offsetScroll)
                this.EventsTrigger("slide", "end")
            })
        });
    }

    openVariantDetail(buttons) {
        buttons.forEach((el) => {
            el.addEventListener('click', () => {
                const start = parseInt(el.dataset.start);
                const urlVariant = el.dataset.urlVariant;

                loadModal(`${urlVariant}`, {
                    "start": start + 1
                })
            })
        })
    }

    toggleObjects(data) {
        const tabs = document.querySelector('.tab-content');
        const itemTabs = tabs.querySelector(".item" + data.objects[0]);

        itemTabs.checked = data.visible;

        if (!data.visible) {
            this.hiddenAnnotations.push(data.objects[0])
        } else {
            this.hiddenAnnotations = this.hiddenAnnotations.filter(item => item !== data.objects[0])
        }

        if (this.settings.editorType === EDITOR_TYPES.cloningrequest) {
            this.addToQuote()
        }
    }

    setContextEditor(context) {
        this.protocolAnnotations.context.pk = context.pk;
        this.protocolAnnotations.context.type = context.type;
    }

    EventsTrigger(action, data) {
        if (this.mediator) {
            this.mediator.trigger(action, data, this)
        }
    }

    EventsOn() {
        if (this.mediator) {
            this.mediator.on("setData", "setData", this);
            this.mediator.on("setAreaView", "setAreaView", this);

            this.mediator.on("updateAnnotations", "setAnnotations", this);
            this.mediator.on("loadRestrictionEnzymes", "loadRestrictionEnzymes", this);
            this.mediator.on("toggleObjects", "toggleObjects", this);

            this.mediator.on("setContextEditor", "setContextEditor", this);
        }
    }
}
